import { IMultiSelectProps as IMultiSelectPropsType } from './multi-select';
export type IMultiSelectProps = IMultiSelectPropsType;
export { MultiSelect } from './multi-select';
export { MultiSelectStore } from './multi-select-store';
